import { Component, OnInit } from '@angular/core';
import { Event } from '@models';
import { ActionResult } from '@models/Event/TaskResult.model';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface InvokeResultsModalParams {
  event: Event;
  actionResults: ActionResult[];
}

@Component({
  standalone: false,
  selector: 'app-invoke-results-modal',
  templateUrl: './invoke-results-modal.component.html',
  styleUrls: ['./invoke-results-modal.component.scss']
})
export class InvokeResultsModalComponent implements OnInit, InvokeResultsModalParams {
  event: Event;
  actionResults: ActionResult[];
  modalDragOn: boolean = false;

  public eventInvokeResultsCols = [
    {field: 'type', header: 'Action Type'},
    {field: 'destination', header: 'Action Details'},
    {field: 'results', header: 'Results'}
  ];

  constructor(public bsModalRef: BsModalRef) { }

  
  ngOnInit(): void {
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }
  
}
